import { DefaultState } from '@src/redux/types'

import {
  MODULE_REGISTRATION,
  MODULE_REGISTRATION_ALL,
  MODULE_REGISTRATION_CREATE,
  MODULE_REGISTRATION_DELETE,
  MODULE_REGISTRATION_LIST,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [MODULE_REGISTRATION]: DefaultState<`${typeof API.MODULE_REGISTRATION}{id}`, 'get'>
  [MODULE_REGISTRATION_ALL]: DefaultState<`${typeof API.MODULE_REGISTRATION_ALL}`, 'get'>
  [MODULE_REGISTRATION_CREATE]: DefaultState<`${typeof API.MODULE_REGISTRATION}`, 'post'>
  // [MODULE_REGISTRATION_REGISTER]: DefaultState<`${typeof API.MODULE_REGISTRATION_REGISTER}`, 'post'>
  [MODULE_REGISTRATION_DELETE]: DefaultState<`${typeof API.MODULE_REGISTRATION}{id}`, 'delete'>
  [MODULE_REGISTRATION_LIST]: DefaultState<`${typeof API.MODULE_REGISTRATION}`, 'get'>
} = () => ({
  [MODULE_REGISTRATION]: defaultState(),
  [MODULE_REGISTRATION_ALL]: defaultState(),
  [MODULE_REGISTRATION_CREATE]: defaultState(),
  // [MODULE_REGISTRATION_REGISTER]: defaultState(),
  [MODULE_REGISTRATION_DELETE]: defaultState(),
  [MODULE_REGISTRATION_LIST]: defaultState(),
})
